import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Field } from "redux-form";
import { url, required, maxFileSize } from "../../../../utils/forms/validators";
import Input from "../../../../components/common/input/Input";
import FileInput from "../../../../components/common/fileInput/FileInput";
import styles from "./CompleteProfile.scss";

export const urlValidation = msg => url(msg);

export const linkedin = urlValidation("Please enter a valid url.");
export const website = urlValidation("Please enter a valid website.");

export const fileSizeValidation = file => maxFileSize(file, 2);

class socialInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      col: props.col || 6,
      social: {
        resume: {
          name: "resume",
          placeholder: "Resumé"
        },
        linkedin: {
          name: "linkedin",
          placeholder: "LinkedIn URL"
        },
        website: {
          name: "website",
          placeholder: "Website (Optional)"
        }
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.links && this.props.links != prevProps.links) {
      if (this.state.social.length - 1 !== this.props.links.length) {
        let social = this.state.social;
        for (let i = 2; i < this.props.links.length; i++) {
          social = {
            ...social,
            [`website-${i}`]: {
              name: `website-${i}`,
              placeholder: "Website"
            }
          };

          this.setState({ social: social }, () =>
            this.props.updateSocial(this.state)
          );
        }
      }
    }
  }

  addElement() {
    this.setState(
      {
        social: {
          ...this.state.social,
          [`website-${Object.keys(this.state.social).length - 1}`]: {
            name: `website-${Object.keys(this.state.social).length - 1}`,
            placeholder: "Website"
          }
        }
      },
      () => this.props.updateSocial(this.state)
    );
  }

  removeElement(el) {
    // Remove from array
    if (this.props.links) {
      let field = this.props.links.pop();
      field.remove = true;
      this.props.links.push({ remove: true });
    }

    // Hide from rendered objects
    let soc = { ...this.state.social };
    delete soc[el[0]];
    this.setState({ social: soc }, () => this.props.updateSocial(this.state));
  }

  onSelect = value => {
    this.setState({
      filename: value
    });
  };

  render() {
    return (
      <div>
        {Object.entries(this.state.social).map((el, index) => (
          <Row key={index} className={styles.item}>
            <Col xs={11} md={this.state.col} className={styles.itemPadding}>
              {el[0] === "resume" ? (
                <Field
                  component={FileInput}
                  name="resume"
                  placeholder="Resumé"
                  validate={fileSizeValidation}
                  onSelect={this.onSelect}
                />
              ) : (
                <Field
                  type="text"
                  placeholder={el[1].placeholder}
                  name={`links[${index - 1}].${el[0]}`}
                  component={Input}
                  validationType="website"
                  validate={
                    el[0] === "website" ? [website] : [linkedin, required]
                  }
                />
              )}
            </Col>
            {index != 2 &&
            index + 1 == Object.entries(this.state.social).length ? (
              <Col xs={1} style={{ paddingTop: 10 }}>
                <button
                  type="button"
                  onClick={() => this.removeElement(el)}
                  style={{
                    backgroundColor: "transparent",
                    color: "#70adcc",
                    border: 0,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    style={{ margin: "5px" }}
                  >
                    <path
                      fill="none"
                      fillRule="evenodd"
                      stroke="#70ADCC"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      d="M8.999 1A7.997 7.997 0 0 0 1 8.999 8.001 8.001 0 1 0 8.999 1zm0 0v0M4.362 9h9.277"
                    />
                  </svg>
                </button>
              </Col>
            ) : (
              ""
            )}
          </Row>
        ))}
        <button
          type="button"
          onClick={() => this.addElement()}
          style={{
            backgroundColor: "transparent",
            color: "#70adcc",
            border: 0,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            margin: 0,
            padding: 0
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            style={{ margin: "5px" }}
          >
            <path
              fill="none"
              fillRule="evenodd"
              stroke="#70ADCC"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="M8.999 1A7.997 7.997 0 0 0 1 8.999 8.001 8.001 0 1 0 8.999 1zm0 3.361v9.277M4.362 9h9.277"
            />
          </svg>
          <div className={styles.addText}>Add another link</div>
        </button>
      </div>
    );
  }
}

export default socialInputs;



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/SocialInputs.js